import React, {useEffect, useState, useMemo} from 'react';
import UseContext from "hooks/useContext";
import ApiDatabase from "server";
import Table from "components/table/table";
import EmptyState from "components/emptyState";
import {useOutletContext} from "react-router-dom";
import Pagination from "components/pagination/pagination";

const CheckedContent = () => {
    const {companyData,refreshTime,language} = UseContext()
    const [arrayTimeSheets, setArrayTimeSheets] = useState([])
    const [isWaiting, setIsWaiting] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const countPerPage = 25;
    const {
        searchValue = '',
        searchType = 'all',
        perimeterIds,
        isPerimeterColumnShown = false,
        onPerimeterFilterRefused,
    } = useOutletContext() || {};
    // A string key so the effect reruns on a new choice, not on a new array.
    const perimeterFilterKey = (perimeterIds || []).join(',');

    useEffect(() => {
        setIsWaiting(true)
        if(!Object.keys(companyData).length) return undefined
        // Drops the answer of a request made for a previous filter.
        let cancelled = false
        const requestedPerimeterIds = perimeterFilterKey ? perimeterFilterKey.split(',') : []
        ApiDatabase.getTimeSheets({id: companyData._id, p: '3', perimeterIds: requestedPerimeterIds},
            (data) => {
                if (cancelled) return
                setArrayTimeSheets(Array.isArray(data) ? data : [])
                setIsWaiting(false)
            },
            (err) => {
                if (cancelled) return
                // A refused filter is cleared, which reloads the list without it.
                if (requestedPerimeterIds.length && onPerimeterFilterRefused?.(err)) return
                console.log(err)
                setArrayTimeSheets([])
                setIsWaiting(false)
            })
        return () => {
            cancelled = true
        }
    }, [companyData, refreshTime, perimeterFilterKey, onPerimeterFilterRefused])

    // Fonction de filtrage selon le type de recherche
    const filterItems = (items) => {
        if (!searchValue) return items;
        
        const searchLower = searchValue.toLowerCase();
        
        return items.filter(item => {
            switch (searchType) {
                case 'releve':
                    return item.id_time_sheet?.toString().toLowerCase().includes(searchLower);
                case 'interimaire':
                    const fullName = `${item.user[0]?.firstname || ''} ${item.user[0]?.lastname || ''}`.toLowerCase();
                    return fullName.includes(searchLower);
                case 'mission':
                    const missionTitle = item.mission[0]?.title?.toLowerCase() || '';
                    const missionId = item.mission[0]?.id_mission?.toString().toLowerCase() || '';
                    return missionTitle.includes(searchLower) || missionId.includes(searchLower);
                case 'all':
                default:
                    const allSearch = `${item.id_time_sheet || ''} ${item.user[0]?.firstname || ''} ${item.user[0]?.lastname || ''} ${item.mission[0]?.title || ''} ${item.mission[0]?.id_mission || ''}`.toLowerCase();
                    return allSearch.includes(searchLower);
            }
        });
    };

    const filteredTimeSheets = useMemo(() => {
        if (!Array.isArray(arrayTimeSheets)) return [];
        return filterItems(arrayTimeSheets);
    }, [arrayTimeSheets, searchValue, searchType]);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchValue, searchType, arrayTimeSheets]);

    const countTotal = Array.isArray(filteredTimeSheets) ? filteredTimeSheets.length : 0;
    const totalPages = Math.max(1, Math.ceil(countTotal / countPerPage));
    const paginatedTimeSheets = Array.isArray(filteredTimeSheets) ? filteredTimeSheets.slice(
        (currentPage - 1) * countPerPage,
        currentPage * countPerPage
    ) : [];

    const titles=[
        'N° de relevé','MISSION', 'Intérimaire','période',
        ...(isPerimeterColumnShown ? [language.getValue('perimeters.listFilter.column')] : []),
    ]

    return (
        <div>
            {
                isWaiting ? (
                    <Table champsBody={[]} champsHeader={titles} showPerimeter={isPerimeterColumnShown} isWaiting={true}/>
                ) : (
                    <>
                        {
                            arrayTimeSheets?.length > 0 ? (
                                filteredTimeSheets?.length > 0 ? (
                                    <>
                                        <Table champsBody={paginatedTimeSheets} champsHeader={titles} showPerimeter={isPerimeterColumnShown}/>
                                    </>
                                ) : (
                                    <EmptyState type={'time_sheet_check'}/>
                                )
                            ) : (
                                    <EmptyState type={'time_sheet_check'}/>
                            )
                        }
                    </>
                )
            }
            {!isWaiting && filteredTimeSheets?.length > 0 && countTotal > countPerPage && (
                <>
                {/* Room for the fixed pagination bar below, so the last row can scroll above it.
                    z-30: under the modal overlay (z-40), which used to leave the bar lit above it. */}
                <div className="h-20" aria-hidden="true"/>
                <div className="fixed bottom-0 left-0 right-0 border-t border-gray-100 bg-white px-8 py-4 z-30 tab:left-[80px] sidebar-expanded:left-64">
                    <Pagination
                        currentPage={currentPage}
                        countPerPage={countPerPage}
                        countTotal={countTotal}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                    />
                </div>
                </>
            )}
        </div>
    );
};

export default CheckedContent;